import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguageLearning } from '../contexts/LanguageLearningContext';

// Unprefixed learning pages (/podcast-lessons, /library, /coach, /learning-paths) are
// the English versions of their /es and /no counterparts. Content follows the
// visitor's preferred learning language when they have one, and English otherwise.
// The route language is applied without saving it, and nothing renders until auth
// and the signed-in profile are ready, so the default language never flashes.
export default function UnprefixedLearningRoute({ children }) {
  const { t } = useTranslation('common');
  const { activeLanguage, setActiveLanguage, preferredLanguage, loading, ready } = useLanguageLearning();
  const isReady = ready ?? !loading;
  const targetLanguage = preferredLanguage || 'en';

  useEffect(() => {
    if (isReady && activeLanguage !== targetLanguage) {
      setActiveLanguage(targetLanguage);
    }
  }, [activeLanguage, isReady, setActiveLanguage, targetLanguage]);

  if (!isReady || activeLanguage !== targetLanguage) {
    return <div>{t('loading', 'Loading...')}</div>;
  }

  return children;
}
